import { IButtonStyles } from 'office-ui-fabric-react/lib/Button';
import { ColorScheme } from 'owa-color-utils/lib/ColorScheme';
import { getOptimalTextColorString } from 'owa-color-utils/lib/colorUtils';
import { getPalette } from 'owa-theme';

// FUTURE: consider rationalizing with owa-calendar-forms-command-bar getColorSchemeFromProps
//         in general, a lot of forms color scheme logic needs rationalizing and consolidation for consistency
export default function getRSVPButtonStyle(colorScheme: ColorScheme): IButtonStyles {
    // Calculate the theme symbols from color scheme. Once Fabric's button supports IStyleOrFunctionObject,
    // we can wrap the button in a <Customizable> and get themeSymbols from function arg theme
    let defaultPalette = getPalette();
    return {
        root: {
            color: getOptimalTextColorString(
                colorScheme.calLighterAlt, // CommandBar background color
                colorScheme,
                colorScheme.calDarkAlt
            ),
            backgroundColor: defaultPalette.white,
            borderColor: defaultPalette.neutralLight,
        },
        rootHovered: {
            backgroundColor: colorScheme.calLighter,
        },

        rootPressed: {
            backgroundColor: colorScheme.calLight,
        },
    };
}
